import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "react-oauth2-code-pkce";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import FamilyHomeTabs from "./FamilyHomeTabs";
import RegisterMember from "./RegisterMember";
import FamilyEventCalendar from "./BirthdayTracker";
import FamilyDirectory from "./FamilyDirectory";
import FamilyTreeDisplay from "./FamilyTreeDisplay";
import FamilyMedia from "./FamilyMedia";
import { motion } from "framer-motion";
import { Home, CalendarDays, Images, Users, TreePine } from "lucide-react";

export default function FamilyHome({ openRegisterImmediately = false },onUpdateMembers) {
  const { id } = useParams();
  const { token } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState("home");
  const [members, setMembers] = useState([]);
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [showRegisterMember, setShowRegisterMember] = useState(false);
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const [showMenu, setShowMenu] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  // pagination state
  const [birthdayPage, setBirthdayPage] = useState(0);
  const [anniversaryPage, setAnniversaryPage] = useState(0);
  const birthdaysPerPage = 6;
  const anniversariesPerPage = 6;

 // Fetch family events/members
const fetchMembers = async () => {
  try {
    const res = await axios.get(`${API_BASE}/family/${id}/events`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const data = res.data?.data || [];

    // Define invalid placeholders from backend
    const invalidPlaceholders = [
      "default-avatar",
      "default-birthday",
      "default-anniversary",
    ];

    // Helper to pick default images
    const getDefaultImage = (type) => {
      const t = type?.toUpperCase();
      if (t === "BIRTHDAY") return "/images/birthday-default.png";
      if (t === "ANNIVERSARY") return "/images/anniversary-default.png";
      return "/images/other-event-default.png";
    };

    // Normalize and patch image URL inside the event itself
    const cleaned = data.map((ev) => {
      const type = ev.eventType?.toUpperCase();
      const defaultImg = getDefaultImage(type);
      const url = ev.imageUrl?.toLowerCase() || "";

      const isInvalid =
        !url ||
        invalidPlaceholders.some((p) => url.includes(p));

      return {
        ...ev,
        imageUrl: isInvalid ? defaultImg : ev.imageUrl,
      };
    });

    // Filter upcoming events only
    const today = new Date();
    const upcoming = cleaned
      .filter((e) => e.eventDateTime && new Date(e.eventDateTime.value) >= today)
      .sort((a, b) => new Date(a.eventDateTime.value) - new Date(b.eventDateTime.value));

    setMembers(upcoming);
  } catch (err) {
    console.error("Error fetching members/events:", err);
  }
};


  useEffect(() => {
    if (token && id) fetchMembers();
  }, [token, id]);

  // Separate event types
  const allBirthdays = members.filter(
    (m) => m.eventType?.toUpperCase() === "BIRTHDAY"
  );

  const allAnniversaries = members.filter(
    (m) => m.eventType?.toUpperCase() === "ANNIVERSARY"
  );

  const otherEvents = members.filter(
    (m) =>
      m.eventType?.toUpperCase() !== "BIRTHDAY" &&
      m.eventType?.toUpperCase() !== "ANNIVERSARY"
  );

  // Pagination helpers
  const getVisibleBirthdays = () => {
    const start = birthdayPage * birthdaysPerPage;
    return allBirthdays.slice(start, start + birthdaysPerPage);
  };
  const getVisibleAnniversaries = () => {
    const start = anniversaryPage * anniversariesPerPage;
    return allAnniversaries.slice(start, start + anniversariesPerPage);
  };

  const formatDate = (dateObj) => {
    if (dateObj?.value) {
      return new Date(dateObj.value).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      });
    }
    return "";
  };


  // Mock family info (can replace with API call later)
    const [familyInfo, setFamilyInfo] = useState({
      name: "Alapatt Family",
      image:
        "https://images.unsplash.com/photo-1589571894960-20bbe2828d0a?auto=format&fit=crop&w=600&q=60",
      location: "Thrissur, Kerala",
      createdNn:"10-12-2025"
    });
const [familyDescription, setFamilyDescription] = useState("");
const [memberCount, setMemberCount] = useState(0);


const fetchFamilyInfo = async () => {
  try {
    const res = await axios.get(`${API_BASE}/family/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = res.data;
    setFamilyDescription(data?.description || "");
    setMemberCount(data?.memberCount || 0);
    setFamilyInfo({
      name: data?.familyName || "Our Family",
      image: data?.avatarFile || "/images/default-family.jpg",
    });
  } catch (err) {
    console.error("Error fetching family info:", err);
  }
};
useEffect(() => {
  if (token && id) {
    fetchFamilyInfo();
    fetchMembers();
  }
}, [token, id]);

  const tabs = [
    { key: "home", label: "Home", icon: <Home className="w-5 h-5" /> },
    { key: "calendar", label: "Calendar", icon: <CalendarDays className="w-5 h-5" /> },
    { key: "photos", label: "Photos", icon: <Images className="w-5 h-5" /> },
    { key: "directory", label: "Directory", icon: <Users className="w-5 h-5" /> },
    { key: "tree", label: "Tree", icon: <TreePine className="w-5 h-5" /> },
  ];
  const shortDescription = familyDescription.substring(0, 250) + "...";
  const handleDeleteFamily = async () => {
    setIsDeleting(true);
    try {
//         alert("Id ------------- "+${id});
      await axios.delete(`${API_BASE}/family/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // After delete redirect to dashboard or home
      window.location.href = "/"; // Change if needed
    } catch (err) {
      console.error("Delete failed", err);
      alert("Failed to delete the family tree. Try again.");
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
     {/*  <FamilyHomeTabs activeTab={activeTab} setActiveTab={setActiveTab} /> */}
        {/* Family Header (Sticky) */}
        <div className="sticky top-0 z-40 pt-[80px] shadow-md bg-background">
          <div className="flex flex-col sm:flex-row items-center justify-between rounded-2xl p-4 md:p-6 max-w-7xl mx-auto">
            <div className="flex items-center space-x-4">
              <img
                src={familyInfo.image || "/images/default-family.jpg"}
                alt={familyInfo.name}
                className="w-20 h-20 rounded-full object-cover border-4 border-indigo-100 shadow"
              />
              <div>
               <h1 className="text-2xl md:text-3xl font-bold text-gray-800">{familyInfo.name}</h1>
                           <p className="text-sm text-gray-500">{familyInfo.createdNn}</p>

              </div>

                      {/* 🌤 Desktop Tabs - Only on sm and up */}
                      <div className="hidden xl-custom:flex overflow-x-auto scrollbar-hide justify-start px-3 py-3 space-x-3">
                        {tabs.map((tab) => (
                          <motion.button
                            key={tab.key}
                            whileTap={{ scale: 0.95 }}
                            onClick={() => setActiveTab(tab.key)}
                            className={`flex items-center gap-2 px-5 py-2 rounded-full text-sm sm:text-base font-medium transition-all duration-300 whitespace-nowrap
                              ${
                                activeTab === tab.key
                                  ? "bg-purple-600 text-white shadow-md"
                                  : "bg-white text-gray-700 hover:bg-purple-100 hover:text-purple-700 border border-purple-200"
                              }`}
                          >
                            {tab.icon}
                            {tab.label}
                          </motion.button>
                        ))}
                      </div>


                    </div>

                    {/* 📱 Mobile Bottom Glassmorphic Tabs */}
                    <div className="xl-custom:hidden fixed bottom-3 left-1/2 transform -translate-x-1/2 z-[9999]
                      w-[92%] max-w-md rounded-3xl border border-purple-200/50
                      bg-white/60 backdrop-blur-xl shadow-xl flex justify-around py-2.5 px-2">
                      {tabs.map((tab) => (
                        <motion.button
                          key={tab.key}
                          whileTap={{ scale: 0.9 }}
                          onClick={() => setActiveTab(tab.key)}
                          className={`flex flex-col items-center text-xs font-medium transition-all duration-300 ${
                            activeTab === tab.key
                              ? "text-purple-700"
                              : "text-gray-600 hover:text-purple-600"
                          }`}
                        >
                          <div
                            className={`p-2.5 rounded-2xl transition-all duration-300 ${
                              activeTab === tab.key
                                ? "bg-gradient-to-br from-purple-200 to-purple-100 shadow-md"
                                : "bg-transparent"
                            }`}
                          >
                            {tab.icon}
                          </div>
                          <span className="text-[11px] mt-1">{tab.label}</span>
                        </motion.button>
                      ))}
                    </div>


            {/* Optional Right-Side Buttons (Links or Tabs) */}

          </div>
        </div>


      {/* HOME TAB */}
      {activeTab === "home" && (
        <div className="p-8 bg-gray-50 min-h-screen">
          {/* About */}
          <div className="bg-white rounded-2xl shadow-lg p-6 mb-6">
            <div className="flex justify-between items-center mb-4 relative">
                          <h2 className="text-xl font-bold text-gray-800">About the Family</h2>

                          {/* 3-Dot Menu */}
                          <button
                            className="p-2 rounded-full hover:bg-gray-200"
                            onClick={() => setShowMenu(!showMenu)}
                          >
                            ⋮
                          </button>

                          {/* Dropdown */}
                          {showMenu && (
                            <div className="absolute right-0 top-10 bg-white border shadow-lg rounded-xl p-2 w-40 z-50">
                              <button
                                className="w-full text-left px-3 py-2 text-red-600 hover:bg-red-100 rounded-lg"
                                onClick={() => {
                                  setShowMenu(false);
                                  setShowDeleteConfirm(true);
                                }}
                              >
                                Delete Family Tree
                              </button>
                            </div>
                          )}
                        </div>
            <p className="text-gray-600 mb-4 text-sm md:text-base">
              {showFullDescription ? familyDescription : shortDescription}
              <button
                onClick={() => setShowFullDescription(!showFullDescription)}
                className="text-indigo-600 hover:text-indigo-800 ml-1"
              >
                {showFullDescription ? "Less" : "More"}
              </button>
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
              <div className="p-4 bg-gray-50 rounded-xl shadow">
                <span className="text-3xl font-bold text-indigo-600">{memberCount}</span>
                <p className="text-gray-500 text-sm mt-1">Members</p>
                <button
                  className="mt-1 text-xs text-green-600 hover:underline"
                  onClick={() => setActiveTab("tree")}
                >
                  + Add Member
                </button>
              </div>
              <div className="p-4 bg-gray-50 rounded-xl shadow">
                <span className="text-3xl font-bold text-indigo-600">{allAnniversaries.length}</span>
                <p className="text-gray-500 text-sm mt-1">Anniversaries</p>
              </div>
              <div className="p-4 bg-gray-50 rounded-xl shadow">
                <span className="text-3xl font-bold text-indigo-600">{allBirthdays.length}</span>
                <p className="text-gray-500 text-sm mt-1">Birthdays</p>
              </div>
              <div className="p-4 bg-gray-50 rounded-xl shadow flex flex-col justify-center">
                <button
                    className="text-sm text-indigo-600 hover:underline text-sm font-medium"
                    onClick={() => setActiveTab("calendar")}
                  >
                    View Events →
                </button>
              </div>
            </div>
          </div>

          {/* Upcoming Birthdays & Anniversaries */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Upcoming Birthdays */}
            <div className="bg-white rounded-2xl shadow-lg p-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold text-gray-800">Upcoming Birthdays</h2>
                <button
                  className="text-sm text-indigo-600 hover:underline"
                  onClick={() => setActiveTab("calendar")}
                >
                  View
                </button>
              </div>
              {allBirthdays.length === 0 ? (
                <p className="text-sm text-gray-500">No upcoming birthdays.</p>
              ) : (
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {getVisibleBirthdays().map((person, idx) => (
                    <div
                      key={idx}
                      className="flex flex-col items-center p-4 bg-gray-50 rounded-xl shadow hover:shadow-md transition"
                    >
                      <img
                        src={person.imageUrl || "/images/birthday-default.png"}
                        alt={person.title}
                        className="w-16 h-16 object-cover rounded-full mb-3"
                      />
                      <p className="font-semibold text-gray-800">{person.title}</p>
                      <p className="text-sm text-gray-500">{formatDate(person.eventDateTime)}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Upcoming Anniversaries */}
            <div className="bg-white rounded-2xl shadow-lg p-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold text-gray-800">Upcoming Anniversaries</h2>
                <button
                  className="text-sm text-indigo-600 hover:underline"
                  onClick={() => setActiveTab("calendar")}
                >
                  View
                </button>
              </div>
              {allAnniversaries.length === 0 ? (
                <p className="text-sm text-gray-500">No upcoming anniversaries.</p>
              ) : (
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {getVisibleAnniversaries().map((event, idx) => (
                    <div
                      key={idx}
                      className="flex flex-col items-center p-4 bg-gray-50 rounded-xl shadow hover:shadow-md transition"
                    >
                      <img
                        src={event.imageUrl || "/images/anniversary-default.png"}
                        alt={event.title}
                        className="w-16 h-16 object-cover rounded-full mb-3"
                      />
                      <p className="font-semibold text-gray-800">{event.title}</p>
                      <p className="text-sm text-gray-500">{formatDate(event.eventDateTime)}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Upcoming Other Events */}

<div className="md:col-span-1 bg-white rounded-2xl shadow-lg p-6">
  <div className="flex justify-between items-center mb-4">
    <h2 className="text-lg font-semibold text-gray-800">Upcoming Events</h2>
    <button
      className="text-sm text-indigo-600 hover:underline"
      onClick={() => setActiveTab("calendar")}
    >
      View
    </button>
  </div>
  {otherEvents.length === 0 ? (
    <p className="text-sm text-gray-500">No upcoming events.</p>
  ) : (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {otherEvents.map((ev, i) => (
        <div
          key={i}
          className="flex flex-col items-center p-4 bg-gray-50 rounded-xl shadow hover:shadow-md transition"
        >
          <img
            src={ev.imageUrl || "/images/other-event-default.png"}
            alt={ev.title}
            className="w-16 h-16 object-cover rounded-full mb-3"
          />
          <p className="font-semibold text-gray-800 text-center">{ev.title}</p>
          <p className="text-sm text-gray-500">{formatDate(ev.eventDateTime)}</p>
        </div>
      ))}
    </div>
  )}
</div>


          </div>
        </div>
      )}

      {/* Other Tabs */}
      {activeTab === "calendar" && (
        <div className="p-0 bg-background">
          <FamilyEventCalendar />
        </div>
      )}
      {activeTab === "photos" && (
        <div className="p-0 bg-background">
          <FamilyMedia />
        </div>
      )}
      {activeTab === "directory" && (
        <div className="p-0 bg-background">
          <FamilyDirectory />
        </div>
      )}
      {activeTab === "tree" && (
        <div className="p-8 bg-background">
          <FamilyTreeDisplay />
        </div>
      )}

    {showDeleteConfirm && (
      <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-[9999]">
        <div className="bg-white p-6 rounded-2xl shadow-xl w-80 text-center">
          <h3 className="text-xl font-semibold text-gray-800 mb-3">Delete Family Tree?</h3>
          <p className="text-gray-600 text-sm mb-6">
            Are you sure you want to delete this family tree?
            This action cannot be undone.
          </p>

          <div className="flex justify-center gap-3">
            <button
              className="px-4 py-2 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300"
              onClick={() => setShowDeleteConfirm(false)}
            >
              Cancel
            </button>

            <button
              disabled={isDeleting}
              className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700"
              onClick={handleDeleteFamily}
            >
              {isDeleting ? "Deleting..." : "Delete"}
            </button>
          </div>
        </div>
      </div>
    )}

    </>
  );
}
